import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/auth";
import { BrandMark } from "@/components/BrandMark";

const NAV = [
  { to: "/", label: "Analytics", end: true },
  { to: "/submissions", label: "Leads", end: false },
  { to: "/tenants", label: "Clients", end: false },
];

export function Layout() {
  const { creds, logout } = useAuth();
  const navigate = useNavigate();
  // Navigate explicitly: a cookie-session user has creds===null already, so
  // logout()'s setCreds(null) is a no-op and RequireAuth would never redirect.
  const onSignOut = async () => {
    await logout();
    navigate("/login", { replace: true });
  };
  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-20 border-b border-line bg-ink-1/80 backdrop-blur-md">
        <div className="mx-auto flex max-w-6xl items-center gap-7 px-6 py-3.5">
          <Link to="/" aria-label="ASTEROI admin — home" className="shrink-0">
            <BrandMark />
          </Link>

          <nav className="flex items-center gap-1">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `relative rounded-lg px-3 py-1.5 text-sm font-medium transition-colors ${
                    isActive ? "text-lime" : "text-dim hover:text-text"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    {item.label}
                    {isActive && (
                      <span
                        aria-hidden="true"
                        className="absolute inset-x-3 bottom-0 h-0.5 rounded-full bg-lime shadow-[0_0_8px_rgba(211,255,78,0.65)]"
                      />
                    )}
                  </>
                )}
              </NavLink>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-3">
            {creds?.username && (
              <span className="hidden font-mono text-xs text-dim sm:inline">{creds.username}</span>
            )}
            <button type="button" onClick={onSignOut} className="btn-ghost">
              Sign out
            </button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
}
